import React from 'react';
import styles from './dot.module.scss';
const Dot = ({ onClick, ...rest }) => {
  const {
    active
  } = rest;

  return (
    <button
      className={active ? styles.active : styles.inactive}
      onClick={() => onClick()}
    ></button>
  );
};

export default Dot;